"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
const FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
const InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Select_1 = __importDefault(require("@material-ui/core/Select"));
const react_1 = __importStar(require("react"));
const lib_1 = require("../../../lib");
const context_1 = __importDefault(require("../context"));
const InputSelect = ({ name, label, type, values, required = false, autoFocus = false, disabled = false, hasError, message, }) => {
    const { obj, updateProperty } = react_1.useContext(context_1.default);
    return (react_1.default.createElement(FormControl_1.default, { disabled: disabled, error: hasError, required: required, fullWidth: true, margin: "dense" },
        react_1.default.createElement(InputLabel_1.default, { htmlFor: name }, label),
        react_1.default.createElement(Select_1.default, { value: lib_1.deepGet(obj, name, ''), onChange: updateProperty(name, type), inputProps: {
                name,
                id: name,
                autoFocus,
            } },
            !required && (react_1.default.createElement(MenuItem_1.default, { value: '' },
                react_1.default.createElement("em", null, "None"))),
            values.map((value) => {
                if (typeof value === 'string')
                    return (react_1.default.createElement(MenuItem_1.default, { key: value, value: value }, value));
                return (react_1.default.createElement(MenuItem_1.default, { key: value.name, value: value.name }, value.label));
            })),
        message && react_1.default.createElement(FormHelperText_1.default, null, message)));
};
exports.default = InputSelect;
//# sourceMappingURL=Select.js.map